module.exports = __webpack_public_path__ + "static/media/hp-home-banner-tablet-@2x.6594f137.jpg";